import React, { Fragment } from "react";
import Icon from "components/shared/Icon";
import Link from "components/shared/Link";

const Breadcrumbs = ({ module }) => {
	const mainClass = "help-breadcrumbs";

	return module ? (
		<div className={mainClass}>
			{module.webLinks?.map((webLink, index) => {
				return (
					<Fragment key={index}>
						<Icon
							icon={index === 0 ? "home" : "next-2"}
							className={`${mainClass}__icon ${mainClass}__${
								index === 0 ? "icon--home" : "icon--arrow"
							}`}
						/>
						<Link {...webLink} className={`${mainClass}__link`}>
							{webLink.title}
						</Link>
					</Fragment>
				);
			})}
		</div>
	) : null;
};

export default Breadcrumbs;
